var _path, _path2, _path3, _mask, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkNoBanks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 200,
    viewBox: "0 0 250 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207 65C210.866 65 214 68.134 214 72C214 75.866 210.866 79 207 79H167C170.866 79 174 82.134 174 86C174 89.866 170.866 93 167 93H189C192.866 93 196 96.134 196 100C196 103.866 192.866 107 189 107H178.826C173.952 107 170 110.134 170 114C170 116.577 172 118.911 176 121C179.866 121 183 124.134 183 128C183 131.866 179.866 135 176 135H93C89.134 135 86 131.866 86 128C86 124.134 89.134 121 93 121H54C50.134 121 47 117.866 47 114C47 110.134 50.134 107 54 107H94C97.866 107 101 103.866 101 100C101 96.134 97.866 93 94 93H69C65.134 93 62 89.866 62 86C62 82.134 65.134 79 69 79H109C105.134 79 102 75.866 102 72C102 68.134 105.134 65 109 65H207ZM207 93C210.866 93 214 96.134 214 100C214 103.866 210.866 107 207 107C203.134 107 200 103.866 200 100C200 96.134 203.134 93 207 93Z",
    fill: "#3B3A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5 96.5L130 62L169.5 96.5L164.5 103.5L163.5 138.5H94V103.5L89.5 96.5Z",
    fill: "#1C1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 116C120.7 111.2 115.167 85.3333 117.5 73L88.5 97.5L96 105L97.5 139.5L161.5 137.5V116Z",
    fill: "#3B3A3A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_5958_2266",
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 53,
    width: 99,
    height: 51,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 80,
    y: 53,
    width: 99,
    height: 51
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.633 66L89.3355 100.206C87.8086 101.502 85.5428 101.41 84.1266 99.9935C82.5218 98.3887 82.6482 95.7504 84.3991 94.3064L129.633 57L174.867 94.3064C176.618 95.7504 176.744 98.3887 175.14 99.9935C173.723 101.41 171.458 101.502 169.931 100.206L129.633 66Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.633 66L89.3355 100.206C87.8086 101.502 85.5428 101.41 84.1266 99.9935C82.5218 98.3887 82.6482 95.7504 84.3991 94.3064L129.633 57L174.867 94.3064C176.618 95.7504 176.744 98.3887 175.14 99.9935C173.723 101.41 171.458 101.502 169.931 100.206L129.633 66Z",
    fill: "#1C1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3355 100.206L87.7176 98.3002H87.7176L89.3355 100.206ZM129.633 66L131.251 64.0941L129.633 62.7208L128.015 64.0941L129.633 66ZM84.1266 99.9935L82.3588 101.761L82.3588 101.761L84.1266 99.9935ZM84.3991 94.3064L85.9897 96.2351H85.9897L84.3991 94.3064ZM129.633 57L131.224 55.0713L129.633 53.7594L128.042 55.0713L129.633 57ZM174.867 94.3064L176.458 92.3777L174.867 94.3064ZM175.14 99.9935L176.907 101.761L176.907 101.761L175.14 99.9935ZM169.931 100.206L171.549 98.3002L169.931 100.206ZM90.9533 102.112L131.251 67.9059L128.015 64.0941L87.7176 98.3002L90.9533 102.112ZM82.3588 101.761C84.6955 104.098 88.4341 104.25 90.9533 102.112L87.7176 98.3002C87.1832 98.7538 86.3901 98.7215 85.8944 98.2257L82.3588 101.761ZM82.8084 92.3777C79.9195 94.7604 79.7109 99.1134 82.3588 101.761L85.8944 98.2258C85.3326 97.664 85.3769 96.7405 85.9897 96.2351L82.8084 92.3777ZM128.042 55.0713L82.8084 92.3777L85.9897 96.2351L131.224 58.9287L128.042 55.0713ZM128.042 58.9287L173.276 96.2351L176.458 92.3777L131.224 55.0713L128.042 58.9287ZM173.276 96.2351C173.889 96.7405 173.934 97.664 173.372 98.2258L176.907 101.761C179.555 99.1134 179.347 94.7604 176.458 92.3777L173.276 96.2351ZM173.372 98.2257C172.876 98.7215 172.083 98.7538 171.549 98.3002L168.313 102.112C170.832 104.25 174.571 104.098 176.907 101.761L173.372 98.2257ZM171.549 98.3002L131.251 64.0941L128.015 67.9059L168.313 102.112L171.549 98.3002Z",
    fill: "#416CD4",
    mask: "url(#path-4-outside-1_5958_2266)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 157.75,
    y: 99.75,
    width: 10.5,
    height: 37.5,
    rx: 2.25,
    fill: "#1C1D1D",
    stroke: "#416CD4",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 109.75,
    y: 112.75,
    width: 10.5,
    height: 24.5,
    rx: 2.25,
    fill: "#1C1D1D",
    stroke: "#416CD4",
    strokeWidth: 2.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 138.75,
    y: 112.75,
    width: 10.5,
    height: 24.5,
    rx: 2.25,
    fill: "#1C1D1D",
    stroke: "#416CD4",
    strokeWidth: 2.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90.75,
    y: 99.75,
    width: 10.5,
    height: 37.5,
    rx: 2.25,
    fill: "#1C1D1D",
    stroke: "#416CD4",
    strokeWidth: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 81.75,
    y: 134.75,
    width: 94.5,
    height: 9.5,
    rx: 2.25,
    fill: "#1C1D1D",
    stroke: "#416CD4",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.496 89.7018C133.947 89.4155 133.351 89.213 132.713 89.0894V86.365H133.961C135.315 86.365 136.412 85.2677 136.412 83.914C136.412 82.5604 135.315 81.463 133.961 81.463H132.713V80.836C132.713 79.4078 131.555 78.25 130.127 78.25C128.699 78.25 127.541 79.4078 127.541 80.836V81.463H127.454C126.325 81.463 125.278 81.7266 124.331 82.2621C123.384 82.7975 122.631 83.5513 122.08 84.5094C121.517 85.4711 121.25 86.5872 121.25 87.829C121.25 89.0924 121.527 90.223 122.115 91.189L122.12 91.1972L122.126 91.2053C122.721 92.1286 123.516 92.8408 124.5 93.3328C125.426 93.7962 126.444 94.0343 127.541 94.058V96.961H124.484C123.13 96.961 122.033 98.0584 122.033 99.412C122.033 100.766 123.13 101.863 124.484 101.863H127.541V102.49C127.541 103.918 128.699 105.076 130.127 105.076C131.555 105.076 132.713 103.918 132.713 102.49V101.73C133.337 101.602 133.93 101.381 134.489 101.066C135.465 100.525 136.229 99.7356 136.778 98.7204C137.356 97.6858 137.627 96.4658 137.627 95.092C137.627 93.8982 137.358 92.8177 136.794 91.8764C136.252 90.9403 135.48 90.2139 134.496 89.7018ZM127.541 86.4038V88.9089C127.426 88.8815 127.318 88.8371 127.213 88.7756L126.833 89.422L127.213 88.7756C127.022 88.6631 126.873 88.5164 126.759 88.3273C126.664 88.1424 126.611 87.9272 126.611 87.667C126.611 87.4068 126.664 87.1916 126.759 87.0067C126.873 86.8176 127.022 86.6709 127.213 86.5585L127.227 86.5504L127.24 86.5417C127.338 86.4784 127.438 86.4328 127.541 86.4038Z",
    fill: "#3B3A3A",
    stroke: "#C6D6FF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNoBanks);
export default __webpack_public_path__ + "static/media/dark_no_banks.d514384f6b7107b5e2aad41f2ab3fc0a.svg";
export { ForwardRef as ReactComponent };